// extracted by mini-css-extract-plugin
export default {"sub-title":"SupplierInfo_sub-title__OUrMM"};